import { PublicClientApplication } from '@azure/msal-browser';

import { MSALCONFIG } from '../config-global';

export const msalInstance = new PublicClientApplication(MSALCONFIG);